export function slider() {


  //.project_slide
  window.onload = function() {
    const project_slide = document.querySelector('.project_slide');
    if(project_slide) {
      const swiper = new Swiper(project_slide, {
        loop: true,
        slidesPerView: 1.8,
        centeredSlides: true,
        speed: 800,
        spaceBetween: 0,
        effect: 'coverflow', 
        coverflowEffect: {
          rotate: 50, // Slide rotate in degrees
          stretch: 0, // Stretch space between slides (in px)
          depth: 100, // Depth offset in px (slides translate in Z axis)
          modifier: 1, // Effect multipler
          scale: .85,
          slideShadows : false, // Enables slides shadows
        },
        grabCursor: true,
        parallax: true,
        pagination: {
          el: '.swiper-pagination--project_slide',
          clickable: true,
        },
        // navigation: {
        //   nextEl: ".swiper-button-next--project_slide",
        //   prevEl: ".swiper-button-prev--project_slide",
        // },
        breakpoints: {
          767: {
            slidesPerView: "auto",
          }
        },
      });
    }

    const archive_slide = document.querySelector('.archive_slide');
    if(archive_slide) {
      const swiper = new Swiper(archive_slide, {
        loop: true,
        slidesPerView: 1.2,
        centeredSlides: true,
        speed: 800,
        spaceBetween: 0,
        effect: 'coverflow', 
        coverflowEffect: {
          rotate: 50, // Slide rotate in degrees
          stretch: 0, // Stretch space between slides (in px)
          depth: 100, // Depth offset in px (slides translate in Z axis)
          modifier: 1, // Effect multipler
          scale: .7,
          slideShadows : false, // Enables slides shadows
        },
        grabCursor: true,
        parallax: true,
        pagination: {
          el: '.swiper-pagination--archive_slide',
          clickable: true,
        },
        breakpoints: {
          767: {
            slidesPerView: "auto",
          }
        },
      });
    }

  }
}